export default {
    checkSignal: "Проверить силу сигнала",
    checkDevice: "Проверить привязку устройства",
    allTable: "Таблица всех состояний промышленного контроля качества",
    successTable: "Таблица успешных состояний промышленного контроля качества",
    failureTable: "Таблица неуспешных состояний промышленного контроля качества",
    Sinspect: "Начать контроль качества",
    clearData: "Очистить данные",
    qualityform: "Форма промышленного контроля качества",
    exportdata: "Экспорт данных",
    succInspect: "Контроль качества пройден",
    allInspect: "Все состояния промышленного контроля качества",
    deviceOn: "Устройство в сети",
    inspectRes: "Результат контроля качества",
    DeviceNotExist: "Устройство не найдено",
    ok: "Контроль качества пройден",
    err: "Контроль качества не пройден",
    clearDataConfirm: "Вы уверены, что хотите очистить данные этого статуса?",
    sensor_temperature: "Температура",
    sensor_humidity: "Влажность",
    sensor_windSpeed: "Скорость ветра",
    sensor_windDirection: "Направление ветра",
    sensor_rainfall: "Осадки",
    sensor_noise: "Шум",
    import_execStatus: "Статус выполнения",
    import_running: "Выполняется",
    import_finished: "Завершено",
    import_errorState: "Ошибка",
}
